import { lazy } from "react";

import { ReportesLayoutV2 } from "../layouts/ReportesLayoutV2";
import RutaProtegida from "@components/RutaProtegida";
import WhiteZone from "@components/WhiteZone";

const ReportesGeneralV2 = lazy(() =>
    import("../components/v2/sections/ReportesGeneralV2").then((m) => ({ default: m.ReportesGeneralV2 })),
);
const ReportesSolicitudesV2 = lazy(() =>
    import("../components/v2/sections/ReportesSolicitudesV2").then((m) => ({ default: m.ReportesSolicitudesV2 })),
);

export const reportesV2Routes = {
    element: <RutaProtegida />,
    children: [
        {
            Component: ReportesLayoutV2,
            path: "/v2/reportes",
            errorElement: <WhiteZone error />,
            children: [
                { index: true, Component: ReportesGeneralV2 },
                { path: "solicitudes", Component: ReportesSolicitudesV2 },
            ],
        },
    ],
};
